import { useId } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { Radio } from 'core-components/library/radio'

import { SIGNER_PICKER_TRANSLATION_KEYS as K } from '../../translations'

import styles from './ParticipationField.module.scss'

export const ParticipationField = ({
  value,
  onChange,
  disabled,
  optionalDisabled = false,
}: {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
  optionalDisabled?: boolean
}) => {
  const name = useId()
  const t = useSafetyTranslation()
  return (
    <div className={styles.participation} role="radiogroup" aria-labelledby={`${name}-label`}>
      <span id={`${name}-label`} className={styles.participationLabel}>
        <Translation text={K.participation} />
      </span>
      <div className={styles.participationOptions}>
        {[
          [K.mandatory, 0],
          [K.optional, 1],
        ].map(([label, option]) => (
          <Radio
            key={label}
            name={name}
            label={t(String(label))}
            value={String(option)}
            checked={value === option}
            disabled={disabled || (option === 1 && optionalDisabled)}
            onChange={(next: string) => onChange(Number(next))}
            className={value === option ? styles.participationSelected : styles.participationOption}
          />
        ))}
      </div>
      {optionalDisabled && (
        <p className={styles.explanation}>
          <Translation text={K.mandatoryRequired} />
        </p>
      )}
    </div>
  )
}
